export default {
    control: (base, state) => ({
        ...base,
        width: 200,
        color: "#F2F2F2",
        background: "transparent",
        border: "0.5px solid #666",
        borderRadius: 0,
        ":hover": {
            border: "0.5px solid #999",
        },
    }),
    input: (base) => ({
        ...base,
        color: "#F2F2F2",
    }),
    singleValue: (base) => ({
        ...base,
        color: "#F2F2F2",
        fontSize: 12,
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    dropdownIndicator: (base, state) => ({
        ...base,
        color: state.isFocused ? "#999" : "#666",
        ":hover": {
            color: "#999",
        },
    }),
    menu: (base, state) => ({
        ...base,
        borderRadius: 0,
        marginTop: 0,
        boxShadow: "none",
        width: 200,
        background: "rgba(26,26,26, 0.9)",
    }),
    option: (base, state) => ({
        ...base,
        color: state.isSelected ? "#1A1A1A" : "#F2F2F2",
        padding: 10,
        fontSize: 12,
        background: state.isSelected ? "#F3D324" : "none",
        ":hover": {
            background: state.isSelected ? "#F3D324" : "rgba(243, 211, 36, 0.6)",
        }
    }),
};



// WEBPACK FOOTER //
// ./src/components/styles/dropdown.style.js